import { roundToPlaces } from "../../utils/roundToPlaces.js";

export function calculatePriceWithTax(priceWithoutTax: number, taxRate: number): number {
	const taxCoefficient = 1 + taxRate / 100;
	const withTax = priceWithoutTax * taxCoefficient;
	return roundToPlaces(withTax, 2);
}
